export default {
 language: 'tw'
}